module.exports = ".actions-bar__button>*{display:contents !important}.actions-bar__button .actions-bar__button-icon{display:block !important}\n"